<script lang="ts">
    export let items: Timeline[]
</script>

{#each items as item}
    <div class="timeline-item {item.alignment}">
        <div class="timeline-content">
            <div>{item.year}</div>
            <div>{@html item.content}</div>
        </div>
    </div>
{/each}
